export const SET_SECURITY = 'SET_SECURITY';
export const SET_SUBSCRIBER_SECURITY = 'SET_SUBSCRIBER_SECURITY';
